import { Transition } from '@headlessui/react';
import { ReactNode, useEffect, useState } from 'preact/compat';

type FadeTransitionProps<T> = {
    show: T;
    children: ReactNode | ((value: NonNullable<T>) => ReactNode);
};

export function FadeTransition<T>(props: FadeTransitionProps<T>) {
    const [lastDefined, setLastDefined] = useState(props.show);
    useEffect(() => {
        if (!!props.show) {
            setLastDefined(props.show);
        }
    }, [props.show]);

    const children =
        typeof props.children === 'function'
            ? lastDefined
                ? props.children(lastDefined as NonNullable<T>)
                : null
            : props.children;

    return (
        <Transition
            show={!!props.show}
            enter="ease-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-500"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
        >
            {children}
        </Transition>
    );
}
